/**
 * PraticaDetailSplit — F-007 Phase 4 (IMPL-P4-005).
 *
 * Layout a due colonne per la detail page operatore:
 *   - sinistra: PDF preview (`PDFPreviewPane`)
 *   - destra:   metadati pratica + datiStrutturati + azioni (release / segnala)
 *
 * Su viewport stretti (< md) le due colonne si impilano. Componente puro di
 * layout: riceve già le props pronte dalla page.
 */
import type { ReactNode } from 'react';

interface PraticaDetailSplitProps {
  left: ReactNode;
  right: ReactNode;
}

export function PraticaDetailSplit({ left, right }: PraticaDetailSplitProps) {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <section
        aria-label="Anteprima PDF"
        className="min-h-[600px] md:sticky md:top-4"
      >
        {left}
      </section>
      <section aria-label="Dettagli pratica" className="space-y-4">
        {right}
      </section>
    </div>
  );
}
